<template>
  <div>
    <Head title="Settings" />
    <h1>Settings</h1>

    <div class="content-box">
      <h3>Edit Settings</h3>
      <ul>
        <li><Link href="/settings/operators">Operators</Link></li>
        <li><Link href="/settings/types">Types / Class</Link></li>
        <li><Link href="/settings/airports">Airports</Link></li>
        <li><Link href="/settings/products">Products</Link></li>
        <li><Link href="/settings/mail">Mail Settings</Link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Icon,
    Link
  },
  layout: Layout,
  props: {
  },
  data() {
    return {
    }
  }
}
</script>
